// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.deployment_process.DeploymentProcess

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface DeploymentProcessData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "DeploymentProcess";
    id: string;
    name: string;
    output_lines: string[];
    output_base_index: number;
    is_finished: boolean;
}

export class DeploymentProcessStore {
    readonly _entity_class_name = "DeploymentProcess" as const;
    id: string;
    name: string;
    output_lines: string[];
    output_base_index: number;
    is_finished: boolean;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: DeploymentProcessData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.output_lines = wrapEntity(data.output_lines, transport, [...chainPath, "output_lines"]);
        this.output_base_index = wrapEntity(data.output_base_index, transport, [...chainPath, "output_base_index"]);
        this.is_finished = wrapEntity(data.is_finished, transport, [...chainPath, "is_finished"]);
        makeObservable(this, {
            id: observable,
            name: observable,
            output_lines: observable,
            output_base_index: observable,
            is_finished: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async stream_from(source: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "stream_from", [source], {});
    }

    async stop(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "stop", [], {});
    }
}

registerEntity("DeploymentProcess", DeploymentProcessStore);
